exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!./styles/index.scss"), "");

// module
exports.push([module.id, "\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-427a9fc7","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 565
// module chunks = 0